export default __webpack_public_path__ + "static/Serious_business-a1f6eafd16db8eb094e7a46ff6137335.png";